import api from "./api";

export const getDetailBookingReserved = async (id) => {
  return api
    .get({
      endpoint: `/booking/own/reserved/${id}`,
      port: process.env.REACT_APP_PORT_BOOK,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
